module.exports = __webpack_public_path__ + "static/xeneco_mediaintegrator_computer-377b87eba665afe17086c621dcc9c89f.png";